export const GA4_ID = process.env.REACT_APP_GA4_ID;

export const initGA4 = () => {
  if (!GA4_ID || typeof window === 'undefined') return;
  if (window.gtag) return; // already initialized
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  script.async = true;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA4_ID, { send_page_view: true });
};

export const sendToGoogleAnalytics = ({ name, delta, value, id }) => {
  if (!GA4_ID || typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, {
    event_category: 'Web Vitals',
    event_label: id,
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    non_interaction: true,
    metric_delta: delta,
    metric_value: value,
  });
};

// Conversion event helper for landing page funnel tracking.
// Silently no-ops when GA4 is not configured (REACT_APP_GA4_ID empty).
export const track = (eventName, params = {}) => {
  if (!eventName || typeof window === 'undefined') return;
  if (!GA4_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
};

// Pre-named event names so call sites stay typo-free and analytics
// dashboards can be built against a known vocabulary.
export const EVENTS = {
  DEMO_DROPZONE_VIEW: 'demo_dropzone_view',
  DEMO_FILE_DROP: 'demo_file_drop',
  DEMO_GENERATION_COMPLETE: 'demo_generation_complete',
  SOFT_SIGNUP_SHOWN: 'soft_signup_shown',
  SOFT_SIGNUP_CLICKED: 'soft_signup_clicked',
  PRICING_VIEW: 'pricing_view',
  PRICING_CTA_CLICK: 'pricing_cta_click',
  COMPARISON_VIEW: 'comparison_view',
  COMPARISON_PIN_COMPLETE: 'comparison_pin_complete',
  HERO_CTA_CLICK: 'hero_cta_click',
  FINAL_CTA_CLICK: 'final_cta_click',
  STICKY_CTA_CLICK: 'sticky_cta_click',
};
